import { render, staticRenderFns } from "./exam-inventory-table.vue?vue&type=template&id=25cfe762&scoped=true"
import script from "./exam-inventory-table.vue?vue&type=script&lang=ts"
export * from "./exam-inventory-table.vue?vue&type=script&lang=ts"
import style0 from "./exam-inventory-table.vue?vue&type=style&index=0&id=25cfe762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cfe762",
  null
  
)

export default component.exports